"use client";

import { useEffect, useContext, useState, createContext } from "react";
import styles from "./ThemeSwitcher.module.css";
import { FiMoon, FiSun } from "react-icons/fi";
import { useLocation } from "react-router-dom";

export default function ThemeSwitcher() {
  const { theme, toggleTheme } = useContext(themeContext);
  const pathname = useLocation().pathname;

  return (
    <button
      onClick={toggleTheme}
      className={[
        styles.themeSwitcher,
        pathname === "/" ? styles.active : "",
      ].join(" ")}
    >
      {theme === "light" ? (
        <FiMoon size={24} color="var(--text-color)" />
      ) : (
        <FiSun size={24} color="var(--text-color)" />
      )}
    </button>
  );
}

const themeContext = createContext("dark");

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState("dark");

  useEffect(() => {
    const localTheme = localStorage.getItem("theme");
    const htmlElement = document.querySelector("html");
    
    if (localTheme && htmlElement) {
      setTheme(localTheme);
      htmlElement.setAttribute("data-theme", localTheme);
      htmlElement.style.colorScheme = localTheme;
    } else {
      htmlElement.setAttribute("data-theme", "dark");
      htmlElement.style.colorScheme = "dark";
      setTheme("dark");
    }
  }, []);

  const toggleTheme = () => {
    const newTheme = theme === "light" ? "dark" : "light";
    const htmlElement = document.querySelector("html");
    
    setTheme(newTheme);
    localStorage.setItem("theme", newTheme);
    htmlElement.setAttribute("data-theme", newTheme);
    htmlElement.style.colorScheme = newTheme;
  };

  return (
    <themeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </themeContext.Provider>
  );
}

export const useTheme = () => useContext(themeContext);
